import React from "react"
import styled from "styled-components"
import { observer } from "mobx-react"

import Spacer from "~/components/Spacer"
import SafeAndSecureLogo from "~/components/SafeAndSecureLogo"
import DesktopContainer from "~/components/DesktopContainer"
import LookupDisclaimer from "~/components/LookupDisclaimer"
import Grid from "./form/Grid"
import SearchFormContainer from "./form/SearchFormContainer"
import useInject from "~/hooks/useInject"
import { DISCLAIMER_TYPES, FETCHER_NAMES_TITLES } from "~/utilities/constants"

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const SafeAndSecureContainer = styled.div`
  display: flex;
  direction: row;
  align-items: center;
`
const SafeAndSecureTextContainer = styled.div`
  font-family: ${({ theme }) => theme.fonts.avenirNextMedium};
  color: ${({ theme }) => theme.colors.primary};
`
const Title = styled.h1`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.avenirNextBold};
  color: ${({ theme }) => theme.colors.menuItem};
  font-size: ${({ isMobile }) => (isMobile ? "1.875rem" : "2.1875rem")};
  font-weight: bold;
`
const SubText = styled.div`
  font-family: ${({ theme }) => theme.fonts.avenirNextMedium};
  color: ${({ theme }) => theme.colors.text.subContent};
  font-size: 1.25rem;
`

const FormContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  flex-wrap: wrap;
`

const mapStore = (store) => ({
  isMobile: store.ui.isMobile,
  fetcherName: store.divorceLookup.fetcherName,
})

const LookupPage = () => {
  const { isMobile, fetcherName } = useInject(mapStore)

  const fetcherTitle = FETCHER_NAMES_TITLES[fetcherName]

  return (
    <PageContainer>
      <DesktopContainer>
        <SafeAndSecureContainer>
          <SafeAndSecureLogo style={{ paddingRight: "8px" }} />
          <SafeAndSecureTextContainer>
            Safe and secure
          </SafeAndSecureTextContainer>
        </SafeAndSecureContainer>

        <Spacer mobile={6} desktop={10} />

        <Title isMobile={isMobile}>
          Lookup your Divorce in {fetcherTitle} state
        </Title>

        <Spacer mobile={29} desktop={34} />

        <SubText isMobile={isMobile}>
          Search Your Divorce in {fetcherTitle} State, an easy and fast to check
          your case
        </SubText>

        <Spacer mobile={25} desktop={65} />

        <FormContainer>
          <Grid>
            <SearchFormContainer />
          </Grid>
        </FormContainer>

        <Spacer mobile={20} desktop={20} />

        <LookupDisclaimer type={DISCLAIMER_TYPES.divorce} />
      </DesktopContainer>

      <Spacer mobile={30} desktop={60} />
    </PageContainer>
  )
}

export default observer(LookupPage)
